const menuItems = []

export default menuItems
